'use strict';

const isMobileOrTabletWidth = require('./modules/util/isMobileOrTabletWidth');
const scrollHelper = require('./modules/helpers/scroll');
const searchsuggest = require('./searchsuggest');

const navRow = $('.js-navigation-row');
const navItemClass = '.js-navigation-item';

let scrollPosition = 0;
const windowDesktop = $(window).width() > 1023;
const windowTabletAndMobile = $(window).width() < 1024;
const windowTablet = $(window).width() > 767 & $(window).width() < 1024;
const windowMobile = $(window).width() < 768;

// search functionality vars
const header = $('.js-header');
const headerActions = $('.js-header-actions');
const searchInputToggle = $('.js-search-input-toggle');
const searchInputField = $('.js-search-input-field');
const searchSuggestions = $('.js-search-quick-links');
const headerLogo = $('.js-header-logo');
const closeSearchIcon = $('.js-close-search-bar');
const searchSuggestionsEl = $('.js-search-suggestions-container');
const searchOverlay = $('.js-search-overlay');
const searchInputClear = $('.js-search-clear');
const searchSuggestionsFirstLink = searchSuggestions.find('a').first();
const searchSuggestionsLastLink = searchSuggestions.find('a').last();
const mainNavToggle = $('.js-nav-toggle');
const desktopNavigation = $('.js-nav-desktop');

function initializeEvents() {
    // init search input events
    searchInputToggle.on('click', function(e){
        if (!headerActions.hasClass('search-expand')){
            e.preventDefault();

            if (windowTabletAndMobile) {
                headerActions.addClass('search-expand');
            }

            searchInputField.focus();
        }
    });

    // close search bar if field gets out of focus
    searchInputToggle.on('blur', function(){
        if (headerActions.hasClass('search-expand')){

            if (!isMobileOrTabletWidth()) {
                closeSearchBar();
            }
        }
    });

    // close search bar on close icon click
    closeSearchIcon.on('click', closeSearchBar);

    // show X icon for clearing input value on mobile
    searchInputField.on('input', function () {
        if (windowTabletAndMobile) {
            if ($(this).val() !== ''){
                searchInputToggle.hide();
                searchInputClear.show();

                if (!searchSuggestionsEl.hasClass('active')) {
                    openSearchBar();
                }
            } else {
                searchInputToggle.show();
                searchInputClear.hide();
            }
        }
    });

    searchInputClear.on('click', function () {
        $(this).hide();
        searchInputField.val('');
        searchInputToggle.show();
    });

    // ------ ACCESSIBILITY EVENTS ---------
    searchInputField.on('focus', function(e){
        if (!headerActions.hasClass('search-expand')) {
            if (windowTabletAndMobile) {
                e.preventDefault();
                $('.js-header-search-wrapper').next().find('> a').focus();
            } else {
                openSearchBar();
            }
        } else {
            if (navRow.length) {
                if (windowTabletAndMobile && !navRow.hasClass('active')) {
                    openSearchBar();
                }
            }

            if ($('.js-navigation-inner').length) {
                if (windowMobile && !$('.js-navigation-inner').hasClass('active')) {
                    openSearchBar();
                }
            }
        }
    });

    searchInputField.on('keyup', function (e) {
        if (e.which == 13) {
            if (searchInputField.val() === ''){
                e.preventDefault();
            }
        } else if (e.which === 27){
            closeSearchBar();
        }
    });

    closeSearchIcon.on('keyup', function(e){
        if (e.which === 13) {
            closeSearchBar();
        }
    });

    searchSuggestionsLastLink.on('blur', function() {
        if (windowDesktop) {
            closeSearchBar();
        }
    });

    searchInputField.on('keydown', function (e) {
        if (e.which === 13 && searchInputField.val().trim() === '') {
            e.preventDefault();
        }
    });

    searchInputToggle.on('click', function (e) {
        if (searchInputField.val().trim() === '') {
            e.preventDefault();
        }
    });

    if (windowTabletAndMobile) {
        closeSearchIcon.on('keydown', function(e){
            if (e.which === 9 && !e.shiftKey) {
                e.preventDefault();
                searchInputField.focus();
            } else if (e.which === 9 && e.shiftKey) {
                e.preventDefault();

                if (searchSuggestionsEl.hasClass('active')) {
                    $(document).find('.js-search-results-holder a:last-child').focus();
                } else {
                    searchSuggestionsLastLink.focus();
                }
            }
        });
        searchInputField.on('keydown', function (e) {
            if (e.which === 9 && !e.shiftKey) {
                e.preventDefault();
                if (searchInputField.val() === '') {
                    searchInputToggle.focus();
                } else {
                    searchInputClear.focus();
                }
            } else if (e.which === 9 && e.shiftKey) {
                e.preventDefault();

                if (searchSuggestionsEl.hasClass('active')) {
                    closeSearchIcon.focus();
                } else if (!searchSuggestionsEl.hasClass('active') && $('.js-navigation-inner').hasClass('active') && windowMobile) {
                    //TODO: refactor when new navigation replaces old one
                    const $mobVisibleLayer = $('.js-nav-mobile').find('.js-visible');
                    if ($mobVisibleLayer.length) {
                        const $mobLastVisibleItem = $mobVisibleLayer.find('> .js-mob-scrollable-container > ul > li:last-child');
                        if ($mobLastVisibleItem.hasClass('has-children')) {
                            $mobLastVisibleItem.find('> .js-mobile-nav-next-lvl').focus();
                        } else {
                            $mobLastVisibleItem.find('> a').focus();
                        }
                    } else {
                        if ($('.js-nav-mobile').find('.js-nav-mobile-additional').length) {
                            $('.js-nav-mobile-additional').find('li:last-child a').focus();
                        } else {
                            $('.js-nav-mobile-main-list').find('> li:last-child > button').focus();
                        }
                    }
                } else {
                    mainNavToggle.focus();
                }
            }
        });
        searchInputToggle.on('keydown', function (e) {
            if (headerActions.hasClass('search-expand')) {
                if (e.which === 9 && !e.shiftKey) {
                    e.preventDefault();

                    if (searchSuggestionsEl.hasClass('active')) {
                        searchSuggestionsFirstLink.focus();
                    } else {
                        if ($('.js-navigation-inner').hasClass('active')) {
                            //TODO: refactor when new navigation replaces old one
                            $('.js-nav-toggle').focus();
                        } else {
                            $(navItemClass).first().find('> a').focus();
                        }
                    }
                } else if (e.which === 9 && e.shiftKey) {
                    e.preventDefault();
                    searchInputField.focus();
                }
            }
        });
        searchInputClear.on('keydown', function (e) {
            if (e.which === 9 && e.shiftKey) {
                e.preventDefault();
                searchInputField.focus();
            }
        });
        searchSuggestionsFirstLink.on('keydown', function (e) {
            if (e.which === 9 && e.shiftKey) {
                e.preventDefault();
                if (searchInputField.val() === '') {
                    searchInputToggle.focus();
                } else {
                    searchInputClear.focus();
                }
            }
        });
        searchSuggestionsLastLink.on('keydown', function (e) {
            if (e.which === 9 && !e.shiftKey) {
                e.preventDefault();
                closeSearchIcon.focus();
            }
        });
        $('.js-header-search-wrapper').next().find('> a').on('keydown', function (e) {
            if (e.which === 9 && e.shiftKey) {
                e.preventDefault();
                searchInputToggle.focus();
            }
        });
    }
}

function openSearchBar() {
    desktopNavigation.addClass('fade-nav');
    headerActions.addClass('search-expand');
    headerLogo.addClass('fade-out');
    mainNavToggle.addClass('fade-out');
    $('.js-nav-toggle').addClass('fade-out'); //TODO: refactor when new navigation replaces old one

    if (searchInputField.val() !== '') {
        const inputValue = searchInputField.val().trim();
        searchInputField.val(inputValue);
    }

    closeSearchIcon.fadeIn(400, function(){
        searchSuggestionsEl.fadeIn(50).addClass('active');
    });
    searchOverlay.fadeIn(400, function(){
        // init event for overlay
        searchOverlay.on('click', searchOverlayClickHandler);
    });


    // lock body scroll
    scrollPosition = $(window).scrollTop();
    $('body').addClass('body--no-scroll');
    $('body').css('top', -scrollPosition + 'px');

    //only on desktop
    if (!windowMobile) {
        searchOverlay.css({'top': header.height() + 'px'});
    }

    //if navigation is active
    if (windowTablet) {
        if (navRow.hasClass('active')) {
            navRow.addClass('all-visible');
        }
    }
}

function closeSearchBar() {
    $('.js-nav-toggle').removeClass('fade-out'); //TODO: refactor when new navigation replaces old one
    mainNavToggle.removeClass('fade-out');
    closeSearchIcon.fadeOut(50);
    searchSuggestionsEl.hide().removeClass('active');
    searchInputClear.hide();
    searchsuggest.clearResults();
    searchInputField.val('');
    searchOverlay.fadeOut(400, function(){
        searchOverlay.off('click', searchOverlayClickHandler);
        desktopNavigation.removeClass('fade-nav');
    });

    $('body').removeClass('body--no-scroll');
    $(window).scrollTop(scrollPosition);

    if (navRow.length) {
        if (!navRow.hasClass('active')) {
            scrollHelper.enableScroll();
            headerActions.removeClass('search-expand');
            headerLogo.removeClass('fade-out');
        } else if (navRow.hasClass('active')) {
            navRow.removeClass('all-visible');
        }

        if (headerActions.hasClass('search-expand')) {
            mainNavToggle.focus();
        }
    }

    //TODO: refactor when new navigation replaces old one
    if ($('.js-navigation-inner').length) {
        if (!$('.js-navigation-inner').hasClass('active')) {
            scrollHelper.enableScroll();
            headerActions.removeClass('search-expand');
            headerLogo.removeClass('fade-out');
        } else if ($('.js-navigation-inner').hasClass('active')) {
            $('.js-navigation-inner').removeClass('all-visible');
            headerLogo.addClass('fade-out');
            headerActions.addClass('search-expand');
            scrollHelper.disableScroll();
            $('.js-nav-toggle').focus();
        }
    }

    searchInputToggle.show();
}

function searchOverlayClickHandler(){
    closeSearchBar();
}

const headerMenu = {
    init: function() {
        initializeEvents();
        searchsuggest.init();
    },
    closeSearchBar: closeSearchBar
};

module.exports = headerMenu;
